<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
    <app-barra-titulo [modulo]="modulo"></app-barra-titulo>
    <section class="content">
        <div class="error-page">
            <div class="error-content">
                <h3><i class="fas fa-exclamation-triangle fidelis"></i> Oops! Algo salió mal.</h3>
                <p>
                    Usted no tiene los privilegios suficientes para ingresar al módulo.
                    Mientras tanto, usted puede regresar al <a [routerLink]="" (click)="redirectInicio()">inicio</a>
                </p>
            </div>
        </div>
    </section>
</div>
<app-footer></app-footer>